import React, { useEffect } from 'react';
import { useLayoutDetection } from '../../../Hooks';
import CompletePropertyProfileContextProvider from '../../../Contexts/CompletePropertyProfileContext/CompletePropertyProfileContext';
import CompletePropertyProfile from './CompletePropertyProfile';
import { useDispatch } from 'react-redux';
import { TOGGLE_LAYOUT } from '../../../store/layout/Actions';

function CompletePropertyProfileEntryPoint() {
  const dispatch = useDispatch();
  const { isNewLayout, hasNewLayout } = useLayoutDetection();
  const display = isNewLayout && hasNewLayout;

  useEffect(() => {
    if (!display) {
      try {
        dispatch(TOGGLE_LAYOUT());
      } catch (error) {}
    } else {
    }
  }, []);

  return display ? (
    <>
      <CompletePropertyProfileContextProvider>
        <CompletePropertyProfile />
      </CompletePropertyProfileContextProvider>
    </>
  ) : null;
}

export default CompletePropertyProfileEntryPoint;
